import { Entity } from '@decahedron/entity';

export default class Property extends Entity {
    public id: string = null;

    public name: string = null;
}
